<style lang="scss"
       module>
@import 'src/brand/brandColors';

.wrapper {
  composes: innerWrap from 'sass-loader!../../brand/structure.module.scss';
  text-align: center;
}

.ctaBlue {
  composes: cta from 'sass-loader!../../brand/typography.module.scss';
  color: $blue;
}

.ctaBlack {
  composes: cta from 'sass-loader!../../brand/typography.module.scss';
  margin-top: 3.8rem;
  margin-bottom: 4.4rem;
  color: $black;
}
</style>
<template>
  <div :class="$style.wrapper">
    <div :class="[isBlack ? $style.ctaBlack : $style.ctaBlue ]">Email us at
      <a href="mailto:criticalsupplies@go2partners.com">criticalsupplies@go2partners.com</a> to find out how we can do the same for you.
    </div>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Cta',
  props: {
    isBlack: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
